module.exports = __webpack_public_path__ + "img/googleDw.4330174c.svg";